import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function LocationMap() {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sportsCultureSlide, setSportsCultureSlide] = useState(0);
  const [parksSlide, setParksSlide] = useState(0);

  const proximityPoints = [
    { name: 'Varese', distance: '8 km', icon: 'ri-building-line' },
    { name: 'Lugano, Switzerland', distance: '30 min', icon: 'ri-map-pin-line' },
    { name: 'Lake Varese', distance: '30 minutes', icon: 'ri-water-flash-line' },
    { name: 'Milan', distance: '50-60 min', icon: 'ri-building-4-line' },
    { name: 'Malpensa Airport', distance: '37 km', icon: 'ri-plane-line' },
    { name: 'Lake Lugano', distance: 'Nearby', icon: 'ri-water-flash-line' }
  ];

  const carouselImages = [
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/9c8e1bbc8852e2502c4ee6af15a6b577.jpeg', caption: t('location_carousel_caption_1') },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/ca29d7307b2ffabf87349bafa717e627.webp', caption: t('location_carousel_caption_2') },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/b035077fdf6744d0839e6400e15d0b42.jpeg', caption: t('location_carousel_caption_3') },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/b5e18a26ae33424eae55da9cce1b909a.jpeg', caption: t('location_carousel_caption_4') },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/b57f05308a45087a58796b902c0f4633.jpeg', caption: t('location_carousel_caption_5') },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/e7932bb693f4c1b42ce3f2155a1c966f.jpeg', caption: t('location_carousel_caption_6') },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/c7f26c0c2de30530d267426013865efb.webp', caption: t('location_carousel_caption_7') },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/a41e73213c041c8023d17aad516e2763.webp', caption: t('location_carousel_caption_9') },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/1326aeb8061cb1c5cdf6792145502a8c.jpeg', caption: t('location_carousel_caption_10') }
  ];

  const handlePrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  };

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  };

  const healthServices = [
    {
      name: t('health_service_1_name'),
      address: t('health_service_1_address'),
      description: t('health_service_1_desc')
    },
    {
      name: t('health_service_2_name'),
      address: t('health_service_2_address'),
      description: t('health_service_2_desc')
    },
    {
      name: t('health_service_3_name'),
      address: t('health_service_3_address'),
      description: t('health_service_3_desc')
    },
    {
      name: t('health_service_4_name'),
      address: t('health_service_4_address'),
      description: t('health_service_4_desc')
    },
    {
      name: t('health_service_5_name'),
      address: t('health_service_5_address'),
      description: t('health_service_5_desc')
    }
  ];

  const sportsCultureImages = [
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/2e3de870c462128d851f2b8fda085a13.png', caption: t('sports_culture_carousel_1') },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/58b1871e93ad0920c70a2ddbedfd1633.jpeg', caption: t('sports_culture_carousel_2') },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/e6de98417512d48df6809057b370098b.jpeg', caption: t('sports_culture_carousel_3') },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/3b0ba6b2f3005d2df2d49803ebfb8561.jpeg', caption: t('sports_culture_carousel_4') }
  ];

  return (
    <section className="py-24 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-4 text-gray-900">
          {t('location_title')}
        </h2>
        <p className="text-center text-gray-600 mb-8 md:mb-16 text-lg">
          {t('location_subtitle')}
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8 md:mb-16">
          {proximityPoints.map((point, index) => (
            <div
              key={index}
              className="flex items-center gap-4 bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-full flex-shrink-0">
                <i className={`${point.icon} text-white text-xl`}></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-lg">{point.name}</h3>
                <p className="text-gray-600">{point.distance}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Carousel Section */}
        <div className="mb-16">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <div className="relative w-full h-[500px] md:h-[600px] lg:h-[700px]">
              <img
                src={carouselImages[currentSlide].url}
                alt={carouselImages[currentSlide].caption}
                className="w-full h-full object-contain md:object-cover brightness-110"
              />
              
              {/* Caption Overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent py-8">
                <p className="text-white text-center text-xl md:text-2xl font-light">
                  {carouselImages[currentSlide].caption}
                </p>
              </div>
            </div>

            {/* Navigation Arrows */}
            <button
              onClick={handlePrevSlide}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full transition-all cursor-pointer z-10"
              aria-label="Previous image"
            >
              <i className="ri-arrow-left-s-line text-3xl text-white"></i>
            </button>

            <button
              onClick={handleNextSlide}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full transition-all cursor-pointer z-10"
              aria-label="Next image"
            >
              <i className="ri-arrow-right-s-line text-3xl text-white"></i>
            </button>

            {/* Slide Indicators */}
            <div className="absolute bottom-20 left-1/2 -translate-x-1/2 flex gap-2 z-10">
              {carouselImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    index === currentSlide 
                      ? 'bg-white w-8' 
                      : 'bg-white/50 hover:bg-white/75'
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="rounded-2xl overflow-hidden shadow-2xl mb-16">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2782.8!2d8.8667!3d45.8167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47868f5e5e5e5e5e%3A0x5e5e5e5e5e5e5e5e!2sVia%20Binaghetto%2C%203%2C%2021051%20Arcisate%20VA%2C%20Italy!5e0!3m2!1sen!2s!4v1640000000000!5m2!1sen!2s"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Villa Location Map"
          ></iframe>
        </div>

        {/* Experience Varese Section */}
        <div className="mt-20">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 text-gray-900">
            {t('varese_experience_title')}
          </h2>
          <p className="text-center text-gray-600 mb-12 text-lg max-w-4xl mx-auto leading-relaxed">
            {t('varese_experience_intro')}
          </p>

          {/* Health Services */}
          <div className="mb-16">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-gray-900">
              {t('health_services_title')}
            </h3>
            <p className="text-gray-600 mb-8 text-lg leading-relaxed">
              {t('health_services_intro')}
            </p>
            
            <div className="space-y-6">
              {healthServices.map((service, index) => (
                <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                  <h4 className="font-bold text-gray-900 text-xl mb-2">{service.name}</h4>
                  <p className="text-gray-600 mb-2 text-sm">{service.address}</p>
                  <p className="text-gray-700 leading-relaxed">{service.description}</p>
                </div>
              ))}
            </div>
            
            <p className="text-gray-600 mt-6 text-base italic">
              {t('health_services_note')}
            </p>
          </div>

          {/* Leisure and Culture */}
          <div className="mb-16">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-gray-900">
              {t('leisure_culture_title')}
            </h3>
            <p className="text-gray-700 mb-6 text-lg leading-relaxed">
              {t('leisure_culture_intro')}
            </p>

            <div className="space-y-6">
              <div className="bg-gray-50 rounded-xl p-6">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('leisure_cinema_title')}</h4>
                <p className="text-gray-700 leading-relaxed">{t('leisure_cinema_desc')}</p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('leisure_theater_title')}</h4>
                <div className="grid md:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('leisure_theater_desc')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/bebe6afc4bb0a89f6c1051fbf7bb1b7c.jpeg"
                      alt={t('leisure_theater_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('leisure_theater_caption')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('leisure_courses_title')}</h4>
                <p className="text-gray-700 leading-relaxed">{t('leisure_courses_desc')}</p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('leisure_festivals_title')}</h4>
                <div className="grid lg:grid-cols-2 gap-6 items-stretch">
                  <div className="flex flex-col justify-center">
                    <p className="text-gray-700 leading-relaxed mb-4">{t('leisure_festivals_desc')}</p>
                    <p className="text-gray-700 leading-relaxed">{t('leisure_festivals_note')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/7b6a30802dd523df712fc31a703502b4.jpeg"
                      alt={t('leisure_festivals_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('leisure_festivals_caption')}</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* Education and International Schools */}
          <div className="mb-16">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-gray-900">
              {t('education_title')}
            </h3>
            <p className="text-gray-700 mb-6 text-lg leading-relaxed">
              {t('education_intro')}
            </p>

            <div className="space-y-6">
              <div className="bg-gray-50 rounded-xl p-6">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('education_european_school_title')}</h4>
                <div className="grid lg:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('education_european_school')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/7a613051a83073caaade115bfa6f1434.jpeg"
                      alt={t('education_european_school_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('education_european_school_caption')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('education_maria_title')}</h4>
                <div className="grid lg:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('education_maria_desc')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/aa2733659dc61fa96b34f6ac3dafde68.png"
                      alt={t('education_maria_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('education_maria_caption')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('education_salesiano_title')}</h4>
                <p className="text-gray-700 leading-relaxed">{t('education_salesiano_desc')}</p>
              </div>
            </div>

            <p className="text-gray-700 leading-relaxed mt-6">{t('education_conclusion')}</p>
          </div>

          {/* Skiing in the Alps */}
          <div className="mb-16">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-gray-900">
              {t('skiing_title')}
            </h3>
            <p className="text-gray-700 mb-8 text-lg leading-relaxed">
              {t('skiing_intro')}
            </p>

            <div className="space-y-6">
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('skiing_macugnaga_title')}</h4>
                <div className="grid md:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('skiing_macugnaga_desc')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/c80cdca33cd2917ea71033e7aa284ec9.jpeg"
                      alt={t('skiing_macugnaga_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('skiing_macugnaga_caption')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('skiing_stmoritz_title')}</h4>
                <div className="grid md:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('skiing_stmoritz_desc')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/7b8a31984adc3a6f9c799e48a0dc04f1.jpeg"
                      alt={t('skiing_stmoritz_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('skiing_stmoritz_caption')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('skiing_mottarone_title')}</h4>
                <div className="grid md:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('skiing_mottarone_desc')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/6854740cbfd16033dacdb41f37e473f5.jpeg"
                      alt={t('skiing_mottarone_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('skiing_mottarone_caption')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('skiing_san_domenico_title')}</h4>
                <div className="grid md:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('skiing_san_domenico_desc')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/e0d4cc9abad6122b564e54d0a4aac148.jpeg"
                      alt={t('skiing_san_domenico_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('skiing_san_domenico_caption')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('skiing_cervinia_title')}</h4>
                <div className="grid md:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('skiing_cervinia_desc')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/c19e1b9723f1637e86e6daf12f9ccb16.jpeg"
                      alt={t('skiing_cervinia_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('skiing_cervinia_caption')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('skiing_cortina_title')}</h4>
                <div className="grid md:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('skiing_cortina_desc')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/d4eaeaed818576e45efd54972e003635.jpeg"
                      alt={t('skiing_cortina_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('skiing_cortina_caption')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Nature & Outdoor Activities */}
          <div className="mb-16">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-gray-900">
              {t('nature_outdoor_title')}
            </h3>
            <p className="text-gray-700 mb-8 text-lg leading-relaxed">
              {t('nature_outdoor_intro')}
            </p>

            <div className="space-y-6">
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('nature_cycling_title')}</h4>
                <p className="text-gray-700 leading-relaxed">{t('nature_cycling_desc')}</p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('nature_hiking_title')}</h4>
                <div className="grid lg:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('nature_hiking_desc')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/6d85964ac33f93598d1c3cc992711894.webp"
                      alt={t('nature_hiking_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('nature_hiking_caption')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('nature_parks_title')}</h4>
                <div className="grid md:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('nature_parks_desc')}</p>
                  </div>
                  <div className="relative h-full min-h-[400px] rounded-lg overflow-hidden">
                    <div className="absolute inset-0 flex transition-transform duration-500" style={{ transform: `translateX(-${parksSlide * 100}%)` }}>
                      <div className="w-full h-full flex-shrink-0 relative">
                        <img
                          src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/aa2e1cd17b0afd197da42974001de563.jpeg"
                          alt="Parks and Gardens 1"
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute bottom-8 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                          <p className="text-white text-sm font-medium text-center">{t('nature_parks_caption_1')}</p>
                        </div>
                      </div>
                      <div className="w-full h-full flex-shrink-0 relative">
                        <img
                          src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/09ccf7ce14ff201a9ab5b7d0b9e985ab.jpeg"
                          alt="Parks and Gardens 2"
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute bottom-8 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                          <p className="text-white text-sm font-medium text-center">{t('nature_parks_caption_2')}</p>
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => setParksSlide((prev) => (prev - 1 + 2) % 2)}
                      className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/80 hover:bg-white rounded-full transition-all cursor-pointer z-10"
                      aria-label="Previous park image"
                    >
                      <i className="ri-arrow-left-s-line text-2xl text-gray-900"></i>
                    </button>
                    <button
                      onClick={() => setParksSlide((prev) => (prev + 1) % 2)}
                      className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/80 hover:bg-white rounded-full transition-all cursor-pointer z-10"
                      aria-label="Next park image"
                    >
                      <i className="ri-arrow-right-s-line text-2xl text-gray-900"></i>
                    </button>
                    <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-2 z-10">
                      {[0, 1].map((index) => (
                        <button
                          key={index}
                          onClick={() => setParksSlide(index)}
                          className={`h-1.5 rounded-full transition-all cursor-pointer ${
                            index === parksSlide ? 'bg-white w-8' : 'bg-white/60 w-6'
                          }`}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('nature_water_title')}</h4>
                <div className="grid lg:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('nature_water_desc')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/af4da6843f85501f0e205cd6d121b25c.jpeg"
                      alt={t('nature_water_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('nature_water_caption')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sports and Leisure */}
          <div className="mb-16">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-gray-900">
              {t('sports_leisure_title')}
            </h3>
            <p className="text-gray-700 mb-8 text-lg leading-relaxed">
              {t('sports_leisure_intro')}
            </p>

            <div className="space-y-6">
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('sports_monza_title')}</h4>
                <div className="grid md:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('sports_monza_desc')}</p>
                  </div>
                  <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                    <img
                      src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/b4c8059034257a38d4c0d05ae45e6cca.jpeg"
                      alt={t('sports_monza_title')}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                      <p className="text-white text-sm font-medium text-center">{t('Autodromo Nazionale di Monza')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h4 className="font-bold text-gray-900 text-xl mb-3">{t('sports_culture_title')}</h4>
                <div className="grid md:grid-cols-2 gap-6 items-stretch">
                  <div className="flex items-center">
                    <p className="text-gray-700 leading-relaxed">{t('sports_culture_desc')}</p>
                  </div>
                  <div className="relative h-full min-h-[400px] rounded-lg overflow-hidden">
                    {sportsCultureImages.map((image, index) => (
                      <div
                        key={index}
                        className={`absolute inset-0 transition-opacity duration-500 ${
                          index === sportsCultureSlide ? 'opacity-100' : 'opacity-0'
                        }`}
                      >
                        <img
                          src={image.url}
                          alt={image.caption}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                          <p className="text-white text-sm font-medium text-center">
                            {image.caption}
                          </p>
                        </div>
                      </div>
                    ))}
                    
                    <button
                      onClick={() => setSportsCultureSlide((prev) => (prev - 1 + sportsCultureImages.length) % sportsCultureImages.length)}
                      className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/80 hover:bg-white rounded-full transition-colors cursor-pointer z-10 shadow-lg"
                      aria-label="Previous image"
                    >
                      <i className="ri-arrow-left-s-line text-gray-900 text-2xl"></i>
                    </button>

                    <button
                      onClick={() => setSportsCultureSlide((prev) => (prev + 1) % sportsCultureImages.length)}
                      className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/80 hover:bg-white rounded-full transition-colors cursor-pointer z-10 shadow-lg"
                      aria-label="Next image"
                    >
                      <i className="ri-arrow-right-s-line text-gray-900 text-2xl"></i>
                    </button>

                    <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2 z-10">
                      {sportsCultureImages.map((_, index) => (
                        <button
                          key={index}
                          onClick={() => setSportsCultureSlide(index)}
                          className={`h-1.5 rounded-full transition-all cursor-pointer ${
                            index === sportsCultureSlide ? 'bg-white w-8' : 'bg-white/60 w-6'
                          }`}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Shopping & Dining */}
          <div className="mb-16">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full">
                <i className="ri-shopping-bag-3-line text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900">{t('shopping_dining_title')}</h3>
            </div>

            <div className="grid md:grid-cols-1 gap-6">
              <div className="space-y-6">
                <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                  <h4 className="font-bold text-gray-900 text-xl mb-3">{t('shopping_title')}</h4>
                  <p className="text-gray-700 leading-relaxed">{t('shopping_desc')}</p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                  <h4 className="font-bold text-gray-900 text-xl mb-3">{t('shopping_buosi_title')}</h4>
                  <div className="grid md:grid-cols-2 gap-8 items-stretch">
                    <div className="flex flex-col justify-center min-h-[400px]">
                      <p className="text-gray-700 leading-relaxed text-lg">{t('shopping_buosi_desc')}</p>
                    </div>
                    <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                      <img
                        src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/92f4fef448db14420f4fce9b7b51c78a.png"
                        alt={t('shopping_buosi_title')}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                        <p className="text-white text-sm font-medium text-center">{t('shopping_buosi_caption')}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                  <h4 className="font-bold text-gray-900 text-xl mb-3">{t('dining_title')}</h4>
                  <div className="grid md:grid-cols-2 gap-6 items-stretch">
                    <div className="flex items-center">
                      <p className="text-gray-700 leading-relaxed">{t('dining_desc')}</p>
                    </div>
                    <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                      <img
                        src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/f1de176d7521ceb52aa4c5631d41d62d.webp"
                        alt={t('dining_title')}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                        <p className="text-white text-sm font-medium text-center">{t('dining_caption')}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Excursions and Special Events */}
          <div className="mb-16">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-full">
                <i className="ri-map-pin-line text-purple-600 text-2xl"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900">{t('excursions_title')}</h3>
            </div>

            <p className="text-gray-700 leading-relaxed mb-8 text-lg">{t('excursions_intro')}</p>

            <div className="grid md:grid-cols-1 gap-6">
              <div className="space-y-6">
                <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-xl p-6 hover:shadow-lg transition-shadow border border-pink-100">
                  <h4 className="font-bold text-gray-900 text-xl mb-3">{t('excursions_milan_title')}</h4>
                  <div className="grid lg:grid-cols-2 gap-6 items-stretch">
                    <div className="flex items-center">
                      <p className="text-gray-700 leading-relaxed">{t('excursions_milan_desc')}</p>
                    </div>
                    <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                      <img
                        src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/6c495ae57de2a5d3e609789affffab46.jpeg"
                        alt={t('excursions_milan_title')}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                        <p className="text-white text-sm font-medium text-center">{t('excursions_milan_caption')}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 hover:shadow-lg transition-shadow border border-blue-100">
                  <h4 className="font-bold text-gray-900 text-xl mb-3">{t('excursions_como_title')}</h4>
                  <div className="grid lg:grid-cols-2 gap-6 items-stretch">
                    <div className="flex items-center">
                      <p className="text-gray-700 leading-relaxed">{t('excursions_como_desc')}</p>
                    </div>
                    <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                      <img
                        src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/db20b56eb89699f17a93b14faf389b5e.jpeg"
                        alt={t('excursions_como_title')}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                        <p className="text-white text-sm font-medium text-center">{t('excursions_como_caption')}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-xl p-6 hover:shadow-lg transition-shadow border border-red-100">
                  <h4 className="font-bold text-gray-900 text-xl mb-3">{t('excursions_lugano_title')}</h4>
                  <div className="grid md:grid-cols-2 gap-6 items-stretch">
                    <div className="flex items-center">
                      <p className="text-gray-700 leading-relaxed">{t('excursions_lugano_desc')}</p>
                    </div>
                    <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                      <img
                        src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/285dd65b209994f50ff26256047c94de.jpeg"
                        alt={t('excursions_lugano_title')}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                        <p className="text-white text-sm font-medium text-center">{t('excursions_lugano_caption')}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 hover:shadow-lg transition-shadow border border-green-100">
                  <h4 className="font-bold text-gray-900 text-xl mb-3">{t('excursions_traditions_title')}</h4>
                  <div className="grid md:grid-cols-2 gap-6 items-stretch">
                    <div className="flex items-center">
                      <p className="text-gray-700 leading-relaxed">{t('excursions_traditions_desc')}</p>
                    </div>
                    <div className="h-full min-h-[400px] rounded-lg overflow-hidden relative">
                      <img
                        src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/5c3678cd208e7a66f82672df0227b54f.jpeg"
                        alt={t('excursions_traditions_title')}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-3 px-4">
                        <p className="text-white text-sm font-medium text-center">{t('excursions_traditions_caption')}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Conclusion */}
                <div className="mt-12 bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl p-8 border border-amber-100">
                  <p className="text-gray-800 leading-relaxed text-lg">
                    {t('excursions_conclusion')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
